import { makeStyles } from '@material-ui/core/styles';
import backgroundIndicadoresFinancieros from '../../../assets/background/indicadores_financieros.png';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1.125rem',
    color: '#42526E',
    fontWeight: 500
  },
  titleTable: {
    fontSize: '1.125rem',
    color: '#42526E',
    fontWeight: 500,
    paddingBottom: '0px'
  },
  textPrimary: {
    color: '#001930',
    fontSize: '35px',
    fontWeight: 700,
    [theme.breakpoints.up('xs')]: {
      fontSize: '30px'
    }
  },
  textSecondary: {
    color: '#024787',
    fontSize: '30px',
    fontWeight: 700,
    [theme.breakpoints.up('xs')]: {
      fontSize: '30px'
    },
    [theme.breakpoints.between('md', 'lg')]: {
      fontSize: '28px'
    }
  },
  textPossible: {
    color: '#001930',
    fontSize: '35px',
    fontWeight: 700,
    [theme.breakpoints.up('xs')]: {
      fontSize: '30px'
    }
  },
  textAproved: {
    color: '#024787',
    fontSize: '35px',
    fontWeight: 700,
    [theme.breakpoints.up('xs')]: {
      fontSize: '30px'
    },
    [theme.breakpoints.between('md', 'lg')]: {
      fontSize: '28px'
    }
  },
  textSuccess: {
    color: '#63B100',
    fontSize: '35px',
    fontWeight: 700,
    [theme.breakpoints.between('md', 'lg')]: {
      fontSize: '28px'
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      fontSize: '28px'
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '35px',
    },
  },
  textCashAvaible: {
    alignItems: 'center',
    display: 'flex',
    [theme.breakpoints.between('md', 'lg')]: {
      paddingLeft: '6px',
    }
  },
  containerTitles: {
    display: 'flex',
    alignItems: 'center',
    // height: '35px'
  },
  containerTitlesPaidSaving: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  containerTitlesTransactionalState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
  },
  containerBoxSearch: {
    margin: '8px',
    // width: '400px',
    [theme.breakpoints.up('xs')]: {
      width: '150px',
    },
    [theme.breakpoints.up(375)]: {
      width: '200px',
    },
    [theme.breakpoints.up(425)]: {
      width: '250px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '400px',
    },
    [theme.breakpoints.up('md')]: {
      width: '450px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '500px',
    },
  },
  containerBoxCashAvailable: {
    // height: '23px',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  containerAlertCashAvailable: {
    // height: '23px',
    borderRadius: '15px',
    padding: '8px 15px',
    marginBottom: '5px',
    border: '1px solid #ff9800',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  mainChartGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
  },
  indicadoresFinancieros: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
    },
    backgroundImage: `url(${backgroundIndicadoresFinancieros})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    minHeight: '100%',
    backgroundPosition: 'top left',
  },
  generalContainerDonut: {
    // height: '100%',
    width: '100%',
    // p: 1,
    [theme.breakpoints.down('md')]: {
      // height: '100%',
    },
    // [theme.breakpoints.between('sm', 'md')]: {
    //   width: '100%',
    // }
  },
  button: {
    backgroundColor: '#024787'
  },
  action: {
    padding: '0px',
    paddingLeft: '20px',
    fontSize: '1.125rem',
    color: '#42526E',
    fontWeight: 500
  },
  utilityBox: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center'
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  arrowBox: {
    backgroundColor: '#024787',
  },
  chartLineBarsBox: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center'
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'right'
    }
  },
  checkBoxChartLine: {
    [theme.breakpoints.down('md')]: {
      paddingTop: '5px',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '20px'
    }
  },
  chartLine: {
    '& #arrow_box': {
      backgroundColor: 'transparent'
    }
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  buttonComplete: {
    width: '90px',
    '&:hover': {
      backgroundColor: '#7a8599',
      color: '#FFFFFF'
    }
  },
  buttonTrade: {
    width: '90px',
    '&:hover': {
      backgroundColor: '#b1d87f',
      color: '#FFFFFF'
    }
  },
  buttonAccount: {
    width: '90px',
    '&:hover': {
      backgroundColor: '#6b778c',
      color: '#FFFFFF'
    }
  },
  buttonProgress: {
    width: '90px',
    '&:hover': {
      backgroundColor: '#fedc77',
      color: '#FFFFFF'
    }
  },
  buttonFinal: {
    width: '90px',
    '&:hover': {
      backgroundColor: '#026ccf',
      color: '#FFFFFF'
    }
  },
  chartDashboard: {
    padding: '8px',
    // height: '280px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      // height: '280px',
    },
  },
  fixedchartHeight: {
    padding: '8px',
    height: '450px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '280px',
    },
  },
  chartDashboardDonut: {
    padding: '8px',
    height: '210px',
    maxHeight: '210px'
  },
  indicatorBox: {
    paddingTop: '20px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      borderRadius: '25px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
  },
  selectedIndicatorBox: {
    paddingTop: '20px',
    backgroundColor: '#FFFFFF',
    borderRadius: '25px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  chartBarCost: {
    // height: '50%',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      alignItems: 'center',
      // marginTop: '20px'
    },
  },
  chartBarPerformance: {
    // height: '50%',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      alignItems: 'center',
    },
  },
  chartBarDonutText: {
    fontWeight: 600,
    color: '#42526E',
    fontSize: '0.8rem'
  },
  utilitiesRadialBarText: {
    fontWeight: 600,
    color: '#42526E',
    fontSize: '0.9rem'
  },
  chartBarDonutAlert: {
    fontWeight: 500,
    color: '#42526E',
    fontSize: '0.875rem'
  },
  chartBarDonutTitle: {
    fontWeight: 600,
    color: '#42526E',
    fontSize: '1.2rem'
  },
  chartBarLineText: {
    color: '#42526E',
    fontSize: '0.825rem'
  },
  SavingValuesText: {
    fontWeight: 600,
    color: 'white',
    fontSize: '0.9rem'
  },
  valuesSavingValues: {
    color: 'white',
    fontSize: '35px',
    fontWeight: 700,
    [theme.breakpoints.up('xs')]: {
      fontSize: '30px'
    }
  },
  containerValuesPaid: {
    padding: '0px 8px',
    height: '100%',
    width: '100%',
  },
  blockedDiv: {
    width: '100%',
    height: '100%',
    zIndex: 99,
    position: 'fixed',
    top: '0%',
    left: '0%',
    backdropFilter: 'blur(3px)',
    background: 'rgba(255, 255, 255, 0.60)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  blockedTextTitle: {
    color: 'rgba(0, 25, 48, 0.75)',
    fontSize: '24px',
    fontWeight: 700,
    margin: '20px 0px',
  },
  blockedText: {
    color: 'rgba(0, 25, 48, 0.75)',
    fontSize: '18px',
    fontWeight: 700,
  },
  datePicker: {
    padding: '16.5px 14px',
    border: '1px solid #42526E66',
    boxSizing: 'content-box',
    borderRadius: '16px',
    color: '#034787',
    height: '1.4375em',
    fontWeight: 400,
    fontSize: '1rem',
  },
  disclaimerText: {
    fontWeight: 400,
    color: '#024787',
    fontSize: '0.8rem',
    fontStyle: 'italic'
  },
}));

export { useStyles };
